import React from 'react';
import './index.sass';

const ProjectSlide = ({slide: {title, code, color, description, customer, technologies, payload, domain, status}}) => {
    return (
        <div className={`Project-Slide Project-Slide--${color}`}>
            {/* Цветная шапка проекта (как у wsgfactory) */}
            <div className="Project-Slide__Head">
                <div className="Project-Slide__Head-Bg" aria-hidden="true">
                    {/* светящиеся неоновые линии в шапке */}
                    <svg viewBox="0 0 400 300" preserveAspectRatio="xMidYMid slice" fill="none">
                        <g stroke="currentColor" strokeWidth="1" opacity="0.12">
                            <line x1="0" y1="60" x2="400" y2="60" />
                            <line x1="0" y1="120" x2="400" y2="120" />
                            <line x1="0" y1="180" x2="400" y2="180" />
                            <line x1="0" y1="240" x2="400" y2="240" />
                            <line x1="100" y1="0" x2="100" y2="300" />
                            <line x1="200" y1="0" x2="200" y2="300" />
                            <line x1="300" y1="0" x2="300" y2="300" />
                        </g>
                        <g stroke="currentColor" strokeWidth="1.4" opacity="0.4">
                            <circle cx="280" cy="150" r="50" />
                            <circle cx="280" cy="150" r="92" strokeDasharray="3 7" />
                            <line x1="120" y1="220" x2="280" y2="150" />
                            <line x1="280" y1="150" x2="360" y2="80" />
                        </g>
                        <g fill="currentColor">
                            <circle cx="280" cy="150" r="4" opacity="0.9" />
                            <circle cx="120" cy="220" r="3" opacity="0.7" />
                            <circle cx="360" cy="80" r="3" opacity="0.7" />
                        </g>
                    </svg>
                </div>

                <div className="Project-Slide__Head-Top">
                    <span className="Project-Slide__Code">{code}</span>
                    <span className="Project-Slide__Status">
                        <span className="Project-Slide__Status-Dot" />
                        {status}
                    </span>
                </div>
                <div className="Project-Slide__Head-Title">{title}</div>
                <div className="Project-Slide__Head-Meta">{domain}</div>
            </div>

            {/* Белое тело */}
            <div className="Project-Slide__Body">
                <p className="Project-Slide__Description">{description}</p>

                <div className="Project-Slide__Info">
                    <div className="Project-Slide__Info-Item">
                        <div className="Project-Slide__Label">Заказчик</div>
                        <div className="Project-Slide__Value">{customer}</div>
                    </div>
                    <div className="Project-Slide__Info-Item">
                        <div className="Project-Slide__Label">Масштаб</div>
                        <div className="Project-Slide__Value">{payload}</div>
                    </div>
                    <div className="Project-Slide__Info-Item Project-Slide__Info-Item--Full">
                        <div className="Project-Slide__Label">Стек</div>
                        <div className="Project-Slide__Tech">
                            {technologies.map((t) => (
                                <span className="Project-Slide__Tech-Tag" key={t}>{t}</span>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProjectSlide;
